"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
var colors = {
  black: '#000000',
  'pale-grey': '#f1f1f2',
  'slate-grey': '#58595b',
  grey100: '#fcfcfd',
  grey200: '#eeeff1',
  grey300: '#e2e5e6',
  grey400: '#565656',
  grey500: '#4e4f51',
  green100: '#29EB7F',
  green200: '#13CE66',
  green300: '#0F9F4F',
  inherit: 'inherit',
  orange: '#ff6000',
  red: '#d0021b',
  transparent: 'transparent',
  white: '#ffffff'
};
exports.colors = colors;